import React, { Component } from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import { Grid, Image } from "semantic-ui-react";
import { Rate } from "../";
import { numberToArray } from "../../helpers/functional";
import { filteredAvailableRates } from "../../reducers/";
import styles from "./styles.less";
import PriceDisplay from "../../containers/PriceDisplay";

class RatesGroup extends Component {
  state = {
    showAllRates: false,
    shouldPushSelectedTostart: false
  };

  componentDidMount() {
    this.setState({ shouldPushSelectedTostart: true });
  }

  componentDidUpdate(prevProps, prevState) {
    /* determain if we should move the selected rate to the start of the list
     only do this after we go away from the room and comming back. (sagiv)*/
    const {
      requestDescriptor: newRequestDescriptor,
      categoryId: newCategoryId
    } = this.props;
    const {
      requestDescriptor: prevRequestDescriptor,
      categoryId: prevCategoryId
    } = prevProps;
    const shouldPushSelectedTostart =
      newCategoryId !== prevCategoryId &&
      prevRequestDescriptor !== newRequestDescriptor;
    if (prevState.shouldPushSelectedTostart !== shouldPushSelectedTostart) {
      this.setState({ shouldPushSelectedTostart });
    }
  }

  expendRates = () => this.setState(() => ({ showAllRates: true }));

  renderRate = rate => {
    const {
      categoryId,
      selectedItemId,
      titles,
      isRtl,
      showClubPrices,
      showAvailability,
      lowAvailabilityCount,
      onItemClick,
      onReadeMoreClick,
      ShowCancellationPolicy,
      isIE
    } = this.props;
    return (
      <Grid.Column
        key={rate.id}
        mobile={16}
        tablet={8}
        computer={5}
        className={styles.rateWrapper}
      >
        <PriceDisplay
          price={rate.totalPrice}
          currentCurrencyCode={rate.currencyCode}
          fallBackCurrencySymbol={rate.currency}
        >
          {ratePriceStr => {
            return (
              <PriceDisplay
                price={rate.simpleClubTotalPrice}
                currentCurrencyCode={rate.currencyCode}
                fallBackCurrencySymbol={rate.currency}
              >
                {ratePriceAfterDiscountStr => {
                  return (
                    <Rate
                      isRtl={isRtl}
                      titles={titles}
                      rateId={rate.id}
                      planName={rate.planName}
                      priceName={rate.priceName}
                      titleName={rate.priceName}
                      price={ratePriceStr}
                      priceCode={rate.priceCode}
                      planCode={rate.planCode}
                      availability={rate.availability}
                      allocationCode={rate.allocationCode}
                      showAvailability={showAvailability}
                      lowAvailabilityCount={lowAvailabilityCount}
                      groupName={`rates_${categoryId}`}
                      active={rate.id === selectedItemId}
                      description={rate.planDescription}
                      onClick={onItemClick}
                      isPackage={rate.isPackage}
                      onReadeMoreClick={onReadeMoreClick}
                      ratePriceAfterDiscount={ratePriceAfterDiscountStr}
                      showClubPrices={showClubPrices}
                      ShowCancellationPolicy={ShowCancellationPolicy}
                      isIE={isIE}
                    />
                  );
                }}
              </PriceDisplay>
            );
          }}
        </PriceDisplay>
      </Grid.Column>
    );
  };
  renderEmptyRates = numberOfPlacholders => {
    let placeHolders = numberToArray(numberOfPlacholders).map(num => (
      <Grid.Column
        key={num}
        mobile={16}
        tablet={8}
        computer={5}
        className={styles.rateWrapper}
      >
        <div className={styles.rateWrapper} />
      </Grid.Column>
    ));
    return placeHolders;
  };

  renderRateImage = imageSrc => {
    return (
      <Grid.Column
        only="computer"
        width={8}
        className={styles.priceImageWrapper}
        verticalAlign="top"
      >
        <Image
          size="huge"
          bordered
          verticalAlign="bottom"
          className={styles.priceImage}
          src={imageSrc}
        />
      </Grid.Column>
    );
  };

  shapeRatesAsRowsGroup = (rates, numOfRatesInRow) => {
    const ratesAsGroups = rates.reduce((result, currentRate, idx) => {
      const isNewGroup = idx % numOfRatesInRow === 0; // n items in group
      const nextPosition = isNewGroup ? result.length : result.length - 1;
      result[nextPosition] = result[nextPosition] || [];
      result[nextPosition].push(currentRate);
      return result;
    }, []);
    return ratesAsGroups;
  };

  renderRatesAsGroups = () => {
    const { titles, rates, selectedItemId } = this.props;
    const { showAllRates, shouldPushSelectedTostart } = this.state;
    const availableRates = filteredAvailableRates(rates);
    const withNoSelectedRate =
      shouldPushSelectedTostart &&
      selectedItemId &&
      availableRates.filter(rate => rate.id !== selectedItemId);
    const effectiverates = withNoSelectedRate || availableRates;
    const selectedRate = availableRates.find(
      rate => rate.id === selectedItemId
    );
    const selectedRatefirst = [
      ...(shouldPushSelectedTostart && selectedRate ? [selectedRate] : []), // conditionally add the selected rate to top of the list if exists
      ...effectiverates
    ];
    const numOfRatesInRow = 3;
    const ratesAsGroups = this.shapeRatesAsRowsGroup(
      selectedRatefirst,
      numOfRatesInRow
    );
    const maxRows = 2;

    return (
      <React.Fragment>
        {ratesAsGroups.map((ratesGroupArray, rowIndex) => {
          const hideRow = !showAllRates && rowIndex >= maxRows;
          const isOnMaxRow = rowIndex === maxRows;
          const showMoreButton = !showAllRates && isOnMaxRow;
          const numberOfEmptyRates = numOfRatesInRow - ratesGroupArray.length; // fill empty rates with placeholder to render aligner grid
          return (
            <React.Fragment key={rowIndex}>
              <Grid.Row
                className={cx(styles.ratesGroupRow, { [styles.hide]: hideRow })}
              >
                {ratesGroupArray.map(rate => this.renderRate(rate))}
                {numberOfEmptyRates > 0 &&
                  this.renderEmptyRates(numberOfEmptyRates)}
              </Grid.Row>
              {showMoreButton && (
                <div
                  className={styles.showAllRatesBtn}
                  onClick={this.expendRates}
                  onKeyDown={this.expendRates}
                  role="button"
                  tabIndex="0"
                >
                  {titles.ShowMoreRates}
                </div>
              )}
            </React.Fragment>
          );
        })}
      </React.Fragment>
    );
  };

  render() {
    return <React.Fragment>{this.renderRatesAsGroups()}</React.Fragment>;
  }
}

RatesGroup.propTypes = {
  isRtl: PropTypes.bool,
  titles: PropTypes.object,
  rates: PropTypes.array,
  showAvailability: PropTypes.bool,
  lowAvailabilityCount: PropTypes.number,
  requestDescriptor: PropTypes.number,
  categoryId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  selectedItemId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onItemClick: PropTypes.func,
  onReadeMoreClick: PropTypes.func,
  showClubPrices: PropTypes.bool,
  ShowCancellationPolicy: PropTypes.bool,
  isIE: PropTypes.bool
};

export default RatesGroup;



// WEBPACK FOOTER //
// ./src/components/RatesGroup/RatesGroup.js